function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBookMenu = function SvgBookMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24698"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20293",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53388"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29340",
    d: "M2 0h15v19H3a3 3 0 0 1-3-3V2a2 2 0 0 1 2-2z",
    transform: "translate(4 3)",
    style: {
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29341",
    d: "M3 0h14v6H3a3 3 0 0 1-3-3 3 3 0 0 1 3-3z",
    transform: "translate(4 16)",
    style: {
      strokeWidth: 2,
      stroke: "currentColor",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 975",
    transform: "translate(9.5 7)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    },
    d: "M6 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 976",
    transform: "translate(9.5 9)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      fill: "none"
    },
    d: "M6 0H0"
  }))));
};

export default SvgBookMenu;